export default __webpack_public_path__ + "static/media/expressJS-logo.04e4743f.png";